import { branch, renderComponent } from 'recompose';
import NoBalance from './NoBalance';
import Balance from './Balance';

const chooseBalance = branch(
  ({ balance }) => balance <= 0,
  renderComponent(NoBalance),
);

export default chooseBalance(Balance);
